import { render, staticRenderFns } from "./q-title.vue?vue&type=template&id=7cf8d6ee&scoped=true&"
import script from "./q-title.vue?vue&type=script&lang=js&"
export * from "./q-title.vue?vue&type=script&lang=js&"
import style0 from "./q-title.vue?vue&type=style&index=0&id=7cf8d6ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf8d6ee",
  null
  
)

export default component.exports